import Chip from '@components/Chip';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';

function SendMethod() {
  return (
        <Column fullWidth spacing={22}>
            <Text color={colors.gray7} fontWeight='bold' size='2xl'>
               전송 수단
            </Text>
            <ChipContainer>
                <Chip isSelected>문자</Chip>
            </ChipContainer>
        </Column>
  );
}

const ChipContainer = styled(Chip.Container)`
    margin-bottom: -2px;
    margin-left: -2px;
    padding: 2px;
`;

export default SendMethod;
